import { useEffect } from "react";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { languageSettingListStateAtom, LanguageSettingObject } from "Recoil/language-setting.atom";
import { fetchLanguageSetting } from "Services/language-setting.service";

/**
 * Recoil query hook
 * @see https://recoiljs.org/docs/guides/asynchronous-data-queries/#use-an-atom
 * @returns 
 */
export function useRefreshLanguageSettingState(): [LanguageSettingObject|undefined, () => Promise<void>] {
  const languageSettingListState = useRecoilValue(languageSettingListStateAtom);
  const refreshLanguageSettingState = useRecoilCallback(({set}) => async () => {
    const results = await fetchLanguageSetting();
    let initializedResult = {
      ...results,
    }
    if (!results.languageSetting) {
      initializedResult.languageSetting = [];
    }
    set(languageSettingListStateAtom, initializedResult);
  }, []);

  useEffect(() => {
    if (languageSettingListState) return;

    refreshLanguageSettingState();
  }, [])

  return [languageSettingListState, refreshLanguageSettingState];
}